export const DISPLAY_CONSTS = {
  BUTTON_TEXT: $localize`Clear`,
};
